module.exports = __webpack_public_path__ + "static/media/list.1f2438ad.svg";